<div data-testid="cohort-retention" class="cohort-retention">
  <div class="cohort-retention__header">
    <div class="cohort-retention__titles">
      <h4 class="cohort-retention__title">Cohort retention</h4>
      <p data-testid="cohort-subtitle" class="cohort-retention__subtitle">
        Companies still active 1, 3 and 6 months after joining, by join month — the last 12 months, whatever the period.
        {{ companies | adbCount:'company':'companies' }}.
        <ng-container *ngIf="companies > 0">Click a cell for who dropped off.</ng-container>
      </p>
    </div>
  </div>
  <ng-container *ngIf="companies > 0; else empty">
    <table data-testid="cohort-table" class="cohort-retention__table">
      <thead>
        <tr>
          <th class="cohort-retention__label">Joined · companies</th>
          <th>Month 1</th>
          <th>Month 3</th>
          <th>Month 6</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows" data-testid="cohort-row">
          <td class="cohort-retention__label">{{ row.label }} · {{ row.size }}</td>
          <td *ngFor="let cell of row.cells" data-testid="cohort-cell" class="cohort-cell"
              [attr.data-kind]="cellKind(cell)"
              [attr.role]="cellKind(cell) === 'value' ? 'button' : null"
              [attr.tabindex]="cellKind(cell) === 'value' ? 0 : null"
              [class.cohort-cell--strong]="cellKind(cell) === 'value' && cell.value > 0.62"
              [style.--cohort-alpha]="cellKind(cell) === 'value' ? alpha(cell.value) : null"
              [title]="cellTitle(row, cell)"
              (click)="openDrill(row, cell)"
              (keydown)="onCellKeydown($event, row, cell)">
            <ng-container [ngSwitch]="cellKind(cell)">
              <ng-container *ngSwitchCase="'value'">{{ cell.value | percent:'1.0-0' }}</ng-container>
              <ng-container *ngSwitchCase="'pending'">from {{ cell.availableFrom | date:'d MMM':'UTC' }}</ng-container>
              <ng-container *ngSwitchDefault>–</ng-container>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="cohort-retention__note">
      <span class="cohort-swatch" data-testid="cohort-swatch" aria-hidden="true"></span>
      Collecting history — a cell fills once every company in the cohort has reached that month.
    </p>
    <p *ngIf="hasNoHistory" data-testid="cohort-nohistory-note" class="cohort-retention__note">
      – No login history that far back yet.
    </p>
  </ng-container>
  <ng-template #empty>
    <app-admin-dashboard-empty *ngIf="failed" data-testid="cohort-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
    <app-admin-dashboard-empty *ngIf="loaded && !failed" data-testid="cohort-empty" icon="fa-regular fa-table-cells"
                               title="No companies joined in the last 12 months in this view"></app-admin-dashboard-empty>
  </ng-template>
</div>
